var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMugTea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.01 64H176.004V128L214.629 166.625C220.629 172.625 224.004 180.75 224.004 189.25V256C224.004 273.625 209.629 288 192.004 288H128.002C110.377 288 96.002 273.625 96.002 256V189.25C96.002 180.75 99.377 172.625 105.377 166.625L144.002 128V64H56C49.625 64 43.5 66.5 39 71S32 81.625 32 88V352C32 405 75.002 448 128.002 448H320.006C373.008 448 416.008 405 416.008 352L416.012 351.996V320H448.01C518.76 320 576.012 262.75 576.012 192S518.76 64 448.01 64ZM448.01 256H416.008V128H448.01C483.385 128 512.01 156.625 512.01 192S483.385 256 448.01 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMugTea);
export default __webpack_public_path__ + "static/media/mug-tea.0737f02272d8adacb433b8dcd9bd7fce.svg";
export { ForwardRef as ReactComponent };